import { Skeleton } from "@/components/ui/skeleton";
import { Card } from "@/components/ui/card";

interface SelectionCardSkeletonProps {
  delay?: number;
}

export const SelectionCardSkeleton = ({ delay = 0 }: SelectionCardSkeletonProps) => {
  return (
    <Card 
      className="flex flex-col items-center justify-center gap-3 rounded-lg border-2 border-border p-6 min-h-[140px] animate-pulse opacity-0 animate-fade-in"
      style={{ 
        animationDelay: `${delay}ms`,
        animationFillMode: 'forwards'
      }}
    >
      <Skeleton className="w-10 h-10 md:w-12 md:h-12 rounded-full" />
      <div className="space-y-2 text-center w-full">
        <Skeleton className="h-5 w-3/4 mx-auto" />
        <Skeleton className="h-4 w-2/3 mx-auto" />
      </div>
    </Card>
  );
};

interface SelectionGridSkeletonProps {
  count?: number;
  columns?: 2 | 3;
}

export const SelectionGridSkeleton = ({ 
  count = 6, 
  columns = 2 
}: SelectionGridSkeletonProps) => {
  const staggerDelay = 60; // milliseconds between each card
  
  return (
    <div className={`grid grid-cols-1 ${columns === 3 ? 'md:grid-cols-3' : 'md:grid-cols-2'} gap-4`}>
      {Array.from({ length: count }).map((_, index) => (
        <SelectionCardSkeleton key={index} delay={index * staggerDelay} />
      ))}
    </div>
  );
};
